// extracted by mini-css-extract-plugin
module.exports = {"popularArea":"PopularAreaList_popularArea__jgkWs","popularAreaList":"PopularAreaList_popularAreaList__ROqAY"};